/** Width for YouTube 16:9 thumbnails (320×180 source); height follows from aspect ratio. */
export const YOUTUBE_BROADCAST_THUMBNAIL_WIDTH = 120;

/** Time window used when fetching recent YouTube broadcasts. */
export const RECENT_BROADCASTS_HOURS = 24;
